import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import "bootstrap/dist/css/bootstrap.min.css";

const TabellaRimessiCompleta = () => {
  const [rimessi, setRimessi] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const dati = data?.RIMESSI?.flat() || [];
        setRimessi(dati);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore:", err);
        setLoading(false);
      });
  }, []);

  const isOld = (dateString) => {
    if (!dateString) return false;
    const dataR = new Date(dateString.split(' ')[0]);
    const oggi = new Date();
    dataR.setHours(0, 0, 0, 0);
    oggi.setHours(0, 0, 0, 0);
    const diffDays = Math.floor((oggi - dataR) / (1000 * 60 * 60 * 24));
    return diffDays >= 2;
  };

  return (
    <div
      className="bg-dark text-light widget-client2 ombra tb"
      style={{ 
        borderRadius: "10px", 
        border: "1px solid #c2c2c2",
        position: "relative",
        height: "400px", // Fondamentale per lo scroll
        display: "flex",
        flexDirection: "column",
        overflow: "hidden" 
      }}
    >
      <div className="mt-2 text-center">
        <span className="text-title">RIMESSI</span>
      </div>

      <style>{`
        /* Area di scroll */
        .scroll-area {
          overflow-y: auto;
          flex-grow: 1;
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none;  /* IE/Edge */
        }
        .scroll-area::-webkit-scrollbar { display: none; } /* Chrome/Safari */

        .table-rimessi { 
          border-collapse: separate; 
          border-spacing: 0; 
          width: 100%;
          margin-bottom: 0;
        }

        .table-rimessi thead th {
          position: sticky;
          top: 0;
          z-index: 10;
          background-color: #212529 !important;
          color: white !important;
          font-size: 0.75rem;
          white-space: nowrap;
        }
        
        /* Gestione Colori Righe */
        .riga-ritardo td {
          background-color: #ffd1dc !important;
          color: #000 !important;
        }

        /* Se NON è in ritardo, metti le celle bianche */
        .riga-normale td {
          background-color: #ffffff !important;
          color: #333 !important;
        }

        .table-rimessi td {
          vertical-align: middle;
          border-bottom: 1px solid #dee2e6;
        }
      `}</style>
      
      {/* APPLICATA CLASSE SCROLL-AREA QUI */}
      <div className="scroll-area">
        <Table hover className="table-rimessi" style={{ fontSize: "0.8rem" }}>
          <thead>
            <tr>
              <th>Dep</th>
              <th>Fornitore</th>
              <th>Ragione Sociale</th>
              <th>Data Rimesso</th>
              <th>Num. Rimesso</th>
              <th>ID BEM</th>
              <th className="text-end">Importo</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="7" className="text-center bg-white">Caricamento...</td></tr>
            ) : rimessi.length === 0 ? (
              <tr><td colSpan="7" className="text-center bg-white">Nessun rimesso trovato</td></tr>
            ) : (
              rimessi.map((row, idx) => {
                const rigaRosa = isOld(row["Data Rimesso"]);
                return (
                  <tr 
                    key={idx} 
                    className={rigaRosa ? "riga-ritardo" : "riga-normale"}
                  >
                    <td>{row["Dep"]}</td>
                    <td>{row["ID Fornitore"]}</td>
                    <td>{row["Ragione Sociale"]}</td>
                    <td>{row["Data Rimesso"]?.split(' ')[0]}</td>
                    <td>{row["Num Rimesso"]}</td>
                    <td>{row["ID BEM"]}</td>
                    <td className="text-end fw-bold">
                      {row["Importo"]} €
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TabellaRimessiCompleta;